__turbopack_context__.v({
  "button-container": "uploadedFileList-module-scss-module__MrV36a__button-container",
  "button-content": "uploadedFileList-module-scss-module__MrV36a__button-content",
  "error-msg": "uploadedFileList-module-scss-module__MrV36a__error-msg",
  "errorIcon": "uploadedFileList-module-scss-module__MrV36a__errorIcon",
  "file-details": "uploadedFileList-module-scss-module__MrV36a__file-details",
  "file-error": "uploadedFileList-module-scss-module__MrV36a__file-error",
  "file-icon": "uploadedFileList-module-scss-module__MrV36a__file-icon",
  "file-info": "uploadedFileList-module-scss-module__MrV36a__file-info",
  "file-item": "uploadedFileList-module-scss-module__MrV36a__file-item",
  "file-item-error": "uploadedFileList-module-scss-module__MrV36a__file-item-error",
  "file-list": "uploadedFileList-module-scss-module__MrV36a__file-list",
  "file-name": "uploadedFileList-module-scss-module__MrV36a__file-name",
  "file-size": "uploadedFileList-module-scss-module__MrV36a__file-size",
  "file-status": "uploadedFileList-module-scss-module__MrV36a__file-status",
  "hint": "uploadedFileList-module-scss-module__MrV36a__hint",
  "remove-icon": "uploadedFileList-module-scss-module__MrV36a__remove-icon",
  "success-icon": "uploadedFileList-module-scss-module__MrV36a__success-icon",
  "warning-icon": "uploadedFileList-module-scss-module__MrV36a__warning-icon",
});
